export default "__VITE_ASSET__BNEaRXMJ__"